import {
    put, call, takeLatest
} from 'redux-saga/effects';
import * as Sentry from '@sentry/react';
import { axios, authenticatedAxios } from '../client';
import {
    FETCH_MERCHANT_PAGE_CONTENT, FETCH_YELP_IMAGES_FOR_MERCHANTS,
    fetchMerchantPageContentFailure,
    fetchMerchantPageContentSuccess, fetchYelpImagesForMerchants,
    UPLOAD_YELP_IMAGE_TO_S3, uploadYelpImageToS3, isYelpImageOk, IS_YELP_IMAGE_OK,
    GET_MERCHANT_ONBOARDING_CONTENT, getMerchantOnboardingContent,
    POST_MERCHANT_ONBOARDING_PARTNER_FORM, postMerchantOnboardingPartnerForm,
    GET_MERCHANT_DEAL_LOCATIONS, getMerchantDealLocations,
    GET_MERCHANT_DEALS_BY_LOCATION, getMerchantDealsByLocation,
    REDEEM_MERCHANT_DEAL, redeemMerchantDeal, GET_ACCESS_DEVELOPMENT_MERCHANT_COUNT,
    getAccessDevelopmentMerchantCount
} from "../actions/merchant";





function* handleGetAccessDevelopmentMerchantCount({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }

    try {
        const response = yield call(authenticatedAxios.get,
            `${window.api_url}/site-secure/access-development/merchants/${payload.id}/active-offer-count`
        );

        yield put(getAccessDevelopmentMerchantCount(response.data, {'sent': true}));

    } catch (error) {
        yield put(getAccessDevelopmentMerchantCount(error, {}, true));
    }
}
export function* watchGetAccessDevelopmentMerchantCount() {
    yield takeLatest(GET_ACCESS_DEVELOPMENT_MERCHANT_COUNT, handleGetAccessDevelopmentMerchantCount);
}


function* handleFetchMerchantPageContent(action) {
    try {
        //Using just axios makes an unauthenticated call. If you need to be authenticated, use authenticatedAxious
        const response = yield call(axios.get,
            `${window.api_url}/site/merchant/${action.data.merchantId}`
        );
        yield put(fetchMerchantPageContentSuccess(response.data));
    } catch (e) {
        yield put(fetchMerchantPageContentFailure(e.response));
    }
}
export function* watchFetchMerchantPageContent() {
    yield takeLatest(FETCH_MERCHANT_PAGE_CONTENT, handleFetchMerchantPageContent);
}




function* handleRedeemMerchantDeal({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }

    try {
        const response = yield call(authenticatedAxios.post,
            `${window.api_url}/site-secure/access-development/offers/${payload.id}/redeem/${payload.redemptionMethod}`
        );

        yield put(redeemMerchantDeal(response.data, {'sent': true}));

    } catch (error) {
        yield put(redeemMerchantDeal(error, {}, true));
    }
}
export function* watchRedeemMerchantDeal() {
    yield takeLatest(REDEEM_MERCHANT_DEAL, handleRedeemMerchantDeal);
}




function* handleGetMerchantDealLocations({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }

    try {
        const response = yield call(authenticatedAxios.get,
            `${window.api_url}/site-secure/access-development/merchants/${payload.merchantId}/locations`,
            {
                params: {
                    postal_code: payload.postal_code
                }
            }
        );
        yield put(getMerchantDealLocations(response.data, {'sent': true}));

    } catch (error) {
        yield put(getMerchantDealLocations(error, {}, true));
    }
}
export function* watchGetMerchantDealLocations() {
    yield takeLatest(GET_MERCHANT_DEAL_LOCATIONS, handleGetMerchantDealLocations);
}



function* handleGetMerchantDealsByLocation({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }

    try {
        const response = yield call(authenticatedAxios.get,
            `${window.api_url}/site-secure/access-development/locations/${payload.locationId}/offers`
        );
        yield put(getMerchantDealsByLocation(response.data, {'sent': true}));

    } catch (error) {
        yield put(getMerchantDealsByLocation(error, {}, true));
    }
}
export function* watchGetMerchantDealsByLocation() {
    yield takeLatest(GET_MERCHANT_DEALS_BY_LOCATION, handleGetMerchantDealsByLocation);
}


function* handleFetchYelpImagesForMerchants({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }

    const paramString = '?' + Object.keys(payload.merchantIds).reduce(function(a, k){
        a.push('merchant_ids[]=' + encodeURIComponent(payload.merchantIds[k]));
        return a;
    }, []).join('&');

    let data;
    try {
        const response = yield call(axios.get,
            `${window.api_url}/site/yelp/merchant-images${paramString}`
        );

        data = response.data;
    } catch (error) {
        yield put(fetchYelpImagesForMerchants(error, {'sent': true, 'success': false}, true));
    }

    yield put(fetchYelpImagesForMerchants(data, {'sent': true, 'success': true}));
}
export function* watchFetchYelpImagesForMerchants() {
    yield takeLatest(FETCH_YELP_IMAGES_FOR_MERCHANTS, handleFetchYelpImagesForMerchants);
}



function* handleIsYelpImageOk({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }

    let data;
    try {
        const response = yield call(axios.get, payload);

        data = response.data;
    } catch (error) {
        Sentry.captureMessage('Merchant page : Yelp : Yelp Image server error', {
            extra: {payload},
            tags: {yelp: "Merchant page",},
        });
        yield put(isYelpImageOk(error, {}, true));
    }

    yield put(isYelpImageOk(data, {'sent': true}));
}
export function* watchIsYelpImageOk() {
    yield takeLatest(IS_YELP_IMAGE_OK, handleIsYelpImageOk);
}


function* handleUploadYelpImageToS3({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }

    let data;
    try {
        const params = new URLSearchParams();
        params.append('image', payload.image);
        const response = yield call(authenticatedAxios.post,
            `${window.react_giftya_base_url}/img/send-to-s3`,
            params
        );

        data = response.data;
    } catch (error) {
        yield put(uploadYelpImageToS3(error, {}, true));
    }

    yield put(uploadYelpImageToS3(data, {'sent': true}));
}
export function* watchUploadYelpImageToS3() {
    yield takeLatest(UPLOAD_YELP_IMAGE_TO_S3, handleUploadYelpImageToS3);
}

function* handleGetMerchantOnboardingContent({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }

    let data;
    try {
        const response = yield call(axios.get,
            `${window.api_url}/site/merchant-onboarding-partner/${payload.slug}`
        );

        data = response.data;
    } catch (error) {
        yield put(getMerchantOnboardingContent(error, {}, true));
    }

    yield put(getMerchantOnboardingContent(data, {'sent': true}));
}
export function* watchGetMerchantOnboardingContent() {
    yield takeLatest(GET_MERCHANT_ONBOARDING_CONTENT, handleGetMerchantOnboardingContent);
}

function* handlePostMerchantOnboardingPartnerForm({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }

    let data;
    try {
        const params = new URLSearchParams();
        params.append('name', payload.name);
        params.append('contact_name', payload.contact_name);
        params.append('contact_phone', payload.contact_phone);
        params.append('contact_email', payload.contact_email);
        params.append('address[address_line1]', payload.address.address_line1);
        params.append('address[locality]', payload.address.locality);
        params.append('address[region]', payload.address.region);
        params.append('address[postal_code]', payload.address.postal_code);
        params.append('address[country]', payload.address.country);
        params.append('url', payload.url);
        params.append('logo_url', payload.logo_url);
        params.append('locations', payload.locations);
        params.append('onboarding_partner_visible_id', payload.onboarding_partner_visible_id);
        params.append('recaptcha_response', payload.recaptcha_response);

        const response = yield call(axios.post,
            `${window.api_url}/site/merchant`,
            params
        );

        data = response.data;
    } catch (error) {
        yield put(postMerchantOnboardingPartnerForm(error, {}, true));
    }

    yield put(postMerchantOnboardingPartnerForm(data, {'sent': true}));
}
export function* watchPostMerchantOnboardingPartnerForm() {
    yield takeLatest(POST_MERCHANT_ONBOARDING_PARTNER_FORM, handlePostMerchantOnboardingPartnerForm);
}